import { Search } from '@material-ui/icons';
import { Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Permisos from '../../../Components/AccordionPermisos/Permisos';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import Firma from '../../../Components/Firma/Firma';
import Loading from '../../../Components/Modals/Loading/Loader';
import { selectUserData } from '../../../redux/Login/LoginSlice';

import swal from 'sweetalert';

import {
  aprobarPermisoEmpleadoEncargado,
  fetchCambiarSuccess,
  fetchCountPermisosAreaReporteId,
  fetchListaPermisosAreaReporteId,
  fetchVerificarEncargadoPermiso,
  selectEsEncargadoBool,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectPermisos,
  selectPermisosCount,
} from './../../../redux/Permisos/PermisosSlice';

import { fetchEmpleadoFirmaExiste, selectEmpleadoFirmaExiste } from '../../../redux/Utility/UtilitySlice';

import { PermissionData } from '../../../context/Component/PermissionData';

export const SolicitudesPermisos = () => {
  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK SELECTOR
  const usuario = useSelector(selectUserData);
  const permisos = useSelector(selectPermisos);
  const isLoading = useSelector(selectIsLoading);
  const permisosCount = useSelector(selectPermisosCount);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const esEncargado = useSelector(selectEsEncargadoBool);
  const validacionFirmaEmpleado = useSelector(selectEmpleadoFirmaExiste);

  // ? HOOK-STATE PAGINACION
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);
  const [page, setPage] = useState(0);

  // ? HOOK-STATE
  const [aprobacionesFilterState, setAprobacionesFilterState] = useState({});
  const [changeEmpleado, setChangeEmpleado] = useState('');
  const [empleado, setEmpleado] = useState('');
  const [listadoPermisoFilter, setListadoPermisoFilter] = useState([]);

  // ? HOOK-STATE PARA ABRIR EL MODAL DE FIRMA.
  const [openFirma, setOpenFirma] = useState(false);

  // ? HOOK-STATE PARA ENVIO DE DATA CON FIRMA
  const [dataFirma, setDataFirma] = useState({ file: '', permisoId: 0 });
  const [validateSendDataToApi, setValidateSendDataToApi] = useState(false);

  // * AREA REPORTE DEL USUARIO LOGEADO
  const areaReporte = parseInt(usuario?.AreaReporteId);

  // * FUNCION PARA OBTENER EL LISTADO DE PERMISOS SEGUN LA CONDICION.
  const cargarPermisos = (aprobacionesFilter) => {
    dispatch(fetchListaPermisosAreaReporteId({ aprobacionesFilter, skipRow, rowsPerPage }));
    dispatch(fetchCountPermisosAreaReporteId(aprobacionesFilter));
  };

  // * FUNCIONES DE PAGINACION.
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // * FUNCIONES GENERALES
  const handleEmpleado = () => {
    setEmpleado(changeEmpleado);
  };

  // * FUNCION PARA REFRESCAR LA VALIDACION DE LA FIRMA DEL EMPLEADO
  const refreshValidacionFirmaEmpleado = () => dispatch(fetchEmpleadoFirmaExiste({ empleadoId: usuario.Id }));

  // * USE-EFFECT
  useEffect(() => {
    if (permisosState.ROLE_APROBAR_PERMISO_DIRECTOR_MINISTRO) {
      const aprobacionesFilterAreaReporteId = {
        empleado: empleado ?? '',
        areaReporteId: 1,
      };

      setAprobacionesFilterState(aprobacionesFilterAreaReporteId);
      cargarPermisos(aprobacionesFilterAreaReporteId, areaReporte);
    } else if (esEncargado) {
      // * EVALUANDO EL AREA-REPORTE-ID DEL USUARIO LOGEADO.
      const aprobacionesFilterAreaReporteId = {
        empleado: empleado ?? '',
        areaReporteId: usuario?.AreaOrganizacionalId,
      };

      setAprobacionesFilterState(aprobacionesFilterAreaReporteId);
      cargarPermisos(aprobacionesFilterAreaReporteId, areaReporte);
    }
  }, [skipRow, rowsPerPage, empleado, esEncargado]);

  useEffect(() => {
    if (isSuccess === 'success' && message.length > 0) {
      cargarPermisos(aprobacionesFilterState);
      swal('Exitoso!', message, 'success');
      dispatch(fetchCambiarSuccess());
      setValidateSendDataToApi(false);
      setOpenFirma(false);
    } else if (isSuccess === 'error') {
      swal('Error', 'Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.', 'error');
      dispatch(fetchCambiarSuccess());
    }
  }, [isSuccess]);

  useEffect(() => {
    if (permisos?.length > 0 && esEncargado) {
      // * FILTRANDO CON LA CONDICION DE QUE EL EMPLEADO-ID NO SEA IGUAL AL QUE SE ENCUENTRA LOGEADO.
      const listaFilter = permisos.filter((x) => x.empleadoId !== parseInt(usuario?.Id));

      // * ASIGNANDO FILTRO AL STATE.
      setListadoPermisoFilter(listaFilter);
    } else if (permisos.length && permisosState.ROLE_APROBAR_PERMISO_DIRECTOR_MINISTRO) {
      setListadoPermisoFilter(permisos);
    }
  }, [permisos]);

  useEffect(() => {
    dispatch(fetchVerificarEncargadoPermiso());
    refreshValidacionFirmaEmpleado();
  }, [usuario]);

  // ? HOOK-EFFECT PARA ENVIAR DATA A API CUANDO SE REQUIERE UNA ACTUALIZACION O CREACION DE FIRMA
  useEffect(() => {
    if (validateSendDataToApi) {
      dispatch(aprobarPermisoEmpleadoEncargado({ ...dataFirma, usuarioId: usuario.Id }));
      setValidateSendDataToApi(false);
    }
  }, [validateSendDataToApi]);

  const validateInputEnable = permisosState.ROLE_APROBAR_PERMISO_DIRECTOR_MINISTRO || esEncargado;

  return (
    <Encabezado title="APROBAR PERMISOS">
      <div className="row mt-2">
        <div className="d-flex justify-content-end">
          <div className="col-6">
            <div className="input-group">
              <label className="align-self-center me-3">EMPLEADO</label>
              <input
                disabled={!validateInputEnable}
                type="text"
                className="form-control"
                id="inlineFormInputGroupUsername"
                value={changeEmpleado}
                onChange={(e) => {
                  e.preventDefault();
                  setChangeEmpleado(e.target.value);
                }}
              />

              <button onClick={() => handleEmpleado()} type="button" className="input-group-text btn-primary-mem" disabled={!esEncargado}>
                <Search />
              </button>
            </div>
          </div>
        </div>
      </div>

      {permisos.length > 0 &&
        listadoPermisoFilter.length > 0 &&
        listadoPermisoFilter.map((permiso, index) => (
          <Permisos
            key={index}
            permiso={permiso}
            buttonActive={true}
            validacionFirmaEmpleado={validacionFirmaEmpleado}
            setOpenFirma={setOpenFirma}
            setDataFirma={setDataFirma}
            dataFirma={dataFirma}
            setValidateSendDataToApi={setValidateSendDataToApi}
          />
        ))}

      {(permisos.length === 0 && isLoading === false) | !validateInputEnable ? (
        <div className="mt-4">
          <Typography variant="h5">No se encontraron solicitudes de permisos.</Typography>
        </div>
      ) : (
        <></>
      )}

      {permisos.length > 0 && listadoPermisoFilter.length > 0 && (
        <TablePagination
          component="div"
          count={permisosCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <Firma
        setOpen={setOpenFirma}
        open={openFirma}
        setDataFirma={setDataFirma}
        setValidateSendDataToApi={setValidateSendDataToApi}
        dataFirma={dataFirma}
      />

      <Loading open={isLoading} />
    </Encabezado>
  );
};
